module.exports = __webpack_public_path__ + "static/media/fbLike.2c08c028.svg";